const prefillProvider = async (
  info: any,
  formik: any,
  setPaymentProviderId: any,
  setPricingId: any,
) => {
  await formik.setFieldValue("paymentProviderId", { uuid: info.id.uuid });
  await setPaymentProviderId({ uuid: info.id.uuid });
  await formik.setFieldValue("customerPricingId", { uuid: info.customerPricingId.uuid });
  await setPricingId(info.customerPricingId.uuid);
};

export const handleOptionClick = async (
  paymentProvider: any,
  { formik, setPaymentProviderId, setPricingId, setProviderType, handleClickOption, setRadioChecked }: any
) => {
  const name = paymentProvider.name.toLowerCase();
  const isPaypal = name.includes("paypal");
  const isCard = name === "card";

  await formik.setFieldValue("providerType", paymentProvider.name);
  await setProviderType(paymentProvider.name);
  await formik.setTouched({}, false);

  if (isPaypal) {
    await prefillProvider(
      paymentProvider.paymentOptions[0].paymentProviderInfo,
      formik, setPaymentProviderId, setPricingId,
    );
    handleClickOption(paymentProvider.name);
    return;
  }

  if (isCard) {
    const options = paymentProvider.paymentOptions ?? [];
    if (options.length === 1) {
      const singleInfo = options[0].paymentProviderInfo;
      await prefillProvider(singleInfo, formik, setPaymentProviderId, setPricingId);
      if (singleInfo.name === "flocash") {
        // Single flocash: redirect immediately, no expansion
        await formik.handleSubmit(formik.values);
        return;
      }
      // Single cybersource: expand and show microform directly
    }
    // Multiple options or single cybersource: expand to show sub-options / microform
    handleClickOption(paymentProvider.name);
    return;
  }

  await formik.setFieldValue("paymentProviderId", { uuid: "" });
  await setPaymentProviderId({ uuid: "" });
  setRadioChecked(false);
  handleClickOption(paymentProvider.name);
};
